// Render any extracted value as a readable string. Recurses into arrays and nested
// objects (e.g. a mailing address) and shows an em dash for empties.
export const renderReviewValue = (value: unknown): string => {
  if (value === null || value === undefined || value === "") return "—";
  // Booleans (is_home_state, authorised signatory) read better as Yes/No.
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (Array.isArray(value)) {
    const items = value
      .map((v) => renderReviewValue(v))
      .filter((s) => s && s !== "—");
    return items.length ? items.join(" · ") : "—";
  }
  if (typeof value === "object") {
    const parts = Object.values(value as Record<string, unknown>)
      .map((v) => (v && typeof v === "object" ? renderReviewValue(v) : v))
      .filter((v) => v !== null && v !== undefined && v !== "" && v !== "—");
    return parts.length ? parts.map(String).join(", ") : "—";
  }
  return String(value);
};
